export default "__VITE_ASSET__666dd254__"